import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

export default new Vuex.Store({
    state: {
        operaGroup:[]
    },
    mutations: {
        setOperaGroup (state,val) {
            state.operaGroup = Object.assign([],val);
        }
    },
    actions: {

    }
});
